export const getPassengerTitle = (firstName: string, lastName: string, isPrimaryPassenger = false) => {
  const isDraftOrEmpty = !firstName || !lastName || firstName.trim() === 'Draft' || lastName.trim() === 'Draft';
  if (isDraftOrEmpty && isPrimaryPassenger) {
    return 'Primary Passenger';
  }

  if (isDraftOrEmpty && !isPrimaryPassenger) {
    return 'Passenger name';
  }

  if (isDraftOrEmpty && isPrimaryPassenger) {
    return 'Primary Passenger';
  }

  return `${firstName} ${lastName}`;
};
